module.exports = __webpack_public_path__ + "img/rodrigo-web-designer.b67cf860.webp";